import { useDebounceValue } from "./useDebounce";

export const useDebouncedSearch = (searchTerm: string, debounce = 300) =>
  useDebounceValue(searchTerm, debounce);
